(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("antd"), require("ecCom"), require("mobx"), require("loadjs"));
	else if(typeof define === 'function' && define.amd)
		define(["antd", "ecCom", "mobx", "loadjs"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("antd"), require("ecCom"), require("mobx"), require("loadjs")) : factory(root["antd"], root["ecCom"], root["mobx"], root["loadjs"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_43__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_49__, __WEBPACK_EXTERNAL_MODULE_13__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/spa/hrm/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 15);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.6' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(4)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(0);
var ctx = __webpack_require__(20);
var hide = __webpack_require__(22);
var has = __webpack_require__(8);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(23);
var IE8_DOM_DEFINE = __webpack_require__(24);
var toPrimitive = __webpack_require__(26);
var dP = Object.defineProperty;

exports.f = __webpack_require__(1) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(10);
var defined = __webpack_require__(11);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(31);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_13__;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends2=__webpack_require__(16);var _extends3=_interopRequireDefault(_extends2);var _antd=__webpack_require__(43);var _ecCom=__webpack_require__(5);var _i18n=__webpack_require__(44);var _mobx=__webpack_require__(49);var mobx=_interopRequireWildcard(_mobx);var _loadjs=__webpack_require__(13);var _loadjs2=_interopRequireDefault(_loadjs);var _loginPluginFactory=__webpack_require__(50);var _loginPluginFactory2=_interopRequireDefault(_loginPluginFactory);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var confirm=_antd.Modal.confirm;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ua=_ecCom.WeaTools.ua;var isIE9=ua.browser==="IE";var toJS=mobx.toJS;var remindNum=0;var getLoginForm=function getLoginForm(params){var langid=params.langid,callback=params.callback,queryParams=params.queryParams;window.currLanguageId=langid;var loginid=params.loginid||'';if(loginid==''){loginid=jQuery('#loginid').val();}var loginFormItems=[];var loginFormHiddenItems=[];var loginSetting={};var qrCode={};var hasMultiLang=false;loginFormItems=[{label:'账号',atype:'account',id:'loginid',name:'loginid',type:'text'},{label:'密码',atype:'password',id:'userpassword',name:'userpassword',type:'password'}];queryParams=queryParams&&toJS(queryParams);if(queryParams&&queryParams.appid&&queryParams.service){if(queryParams.message=='311'&&remindNum==0){_antd.message.error(getLabel('124919',"用户名或密码错误"),3);remindNum=remindNum+1;}}_ecCom.WeaTools.callApi('/api/hrm/login/getLoginForm','POST',{loginid:loginid,langid:langid}).then(function(result){// loginFormItems = [
//     {label: '账号', atype: 'account', id: 'loginid', name: 'loginid', type: 'text'},
//     {label: '密码', atype: 'password', id: 'userpassword', name: 'userpassword', type: 'password'},
//     {label: '验证码', atype: 'validatecode', id: 'validatecode', name: 'validatecode', type: 'text'},
//     {label: '动态令牌口令', atype: 'common', id: 'tokenAuthKey', name: 'tokenAuthKey', type: 'text'}
// ];
loginFormItems=result.formItems;loginSetting=result.loginSetting;qrCode=result.qrcode;hasMultiLang=loginSetting.hasMultiLang;loginFormHiddenItems=[{html:'<input type="hidden" id="messages" name="messages" value="">'}];new _loginPluginFactory2.default().getLocalPlugin(result,function(){window.loginPlugin&&window.loginPlugin.init();});if(callback&&typeof callback=='function')callback({hasMultiLang:hasMultiLang,loginFormItems:loginFormItems,loginFormHiddenItems:loginFormHiddenItems,loginSetting:loginSetting,qrCode:qrCode});}).catch(function(err){_antd.message.error(err);if(callback&&typeof callback=='function')callback({hasMultiLang:hasMultiLang,loginFormItems:loginFormItems,loginFormHiddenItems:loginFormHiddenItems,loginSetting:loginSetting,qrCode:qrCode});});};var login=function login(params){var openRSA=params.loginSetting.openRSA;if(openRSA&&openRSA=='1'){//启用RSA加密
__RSAEcrypt__.refreshRsaCode(function(){loginSync(params);});}else{loginSync(params);}};var loginSync=function loginSync(params){var _params$loginSetting=params.loginSetting,userUsbType=_params$loginSetting.userUsbType,hasMultiLang=_params$loginSetting.hasMultiLang,hasValidateCode=_params$loginSetting.hasValidateCode,validateCodeKey=_params$loginSetting.validateCodeKey,numValidateWrong=_params$loginSetting.numValidateWrong,validateType=_params$loginSetting.validateType,showDynamicPwd=_params$loginSetting.showDynamicPwd,openRSA=_params$loginSetting.openRSA;var langid=params.langid,success=params.success,failure=params.failure,logintype=params.logintype,queryParams=params.queryParams;var loginid=jQuery('#loginid').val();var userpassword=jQuery('#userpassword').val();var dynamicPassword=jQuery('#dynamicPassword').val();var loginidRsa=loginid;var userpasswordRsa=userpassword;if(openRSA&&openRSA=='1'){//启用RSA加密
userpasswordRsa=__RSAEcrypt__.rsa_data_encrypt(userpassword);loginidRsa=__RSAEcrypt__.rsa_data_encrypt(loginid);}var tokenAuthKey=jQuery('#tokenAuthKey')?jQuery('#tokenAuthKey').val():'';var validatecode=jQuery('#validatecode')?jQuery('#validatecode').val():'';var messages=jQuery('#messages')?jQuery('#messages').val():'';_antd.message.destroy();if(jQuery('#userpassword')&&jQuery('#userpassword').length>0){if(loginid==''||userpassword==''){_antd.message.error(getLabel('386478',"请输入用户名、密码"),3);if(failure&&typeof failure=='function')failure();return;}}if(jQuery('#dynamicPassword')&&jQuery('#dynamicPassword').length>0){if(dynamicPassword==''){_antd.message.error(getLabel('20289',"请输入动态密码"),3);if(failure&&typeof failure=='function')failure();return;}}if(hasValidateCode&&validatecode==''){_antd.message.error(getLabel('84270',"请输入验证码"),3);if(failure&&typeof failure=='function')failure();return;}if(userUsbType=='3'){if(tokenAuthKey==''){_antd.message.warning(getLabel('84271',"请输入动态令牌口令"));if(failure&&typeof failure=='function')failure();return;}else if(!isdigit(tokenAuthKey)||tokenAuthKey.length!=6){_antd.message.warning(getLabel('386435',"动态令牌口令必须为6位数字！"));if(failure&&typeof failure=='function')failure();return;}}queryParams=toJS(queryParams);if(queryParams&&queryParams.appid&&queryParams.service){queryParams.loginid=loginid;queryParams.userpassword=userpassword;queryParams.isRememberAccount=params.isRememberAccount?'1':'0';queryParams.isRememberPassword=params.isRememberPassword?'1':'0';queryParams.validatecode=validatecode;queryParams.validateCodeKey=validateCodeKey;var tmps=[];jQuery("body").append("<form name='ssoForm'></form>");var form=jQuery("form[name='ssoForm']");form.attr("action",'/login/VerifyLoginWeaversso.jsp');form.attr("method","post");form.attr("style","display:none");for(var key in queryParams){form.append("<input type='text' name='"+key+"' value = '"+queryParams[key]+"'></input>");}//跳转到sso
form.submit();return;}var plugin=params.plugin;var checkWeakPassword=function checkWeakPassword(nCallback){_ecCom.WeaTools.callApi('/api/hrm/password/isWeakPassword','GET',{password:userpasswordRsa}).then(function(datas){var weakPasswordDisable=datas.weakPasswordDisable,isWeakPassword=datas.isWeakPassword;if(isWeakPassword&&weakPasswordDisable==="1"){var url='/spa/hrm/index_mobx.html#/main/hrm/weakPassConfirm';var dialog=ecCom.WeaTools.createDialog({url:url,title:getLabel(131329,'信息确认'),icon:"icon-coms02-Warning",iconBgcolor:"#ff9900",style:{width:380,height:161},onCancel:function onCancel(){failure({reflashValidateCode:true});},callback:function callback(){showDialog("",'/spa/hrm/index_mobx.html#/main/hrm/password',{width:800,height:500},"",function(){return failure({reflashValidateCode:true});});}});dialog.show();}else{nCallback();}}).catch(function(){nCallback();});};_ecCom.WeaTools.callApi('/api/hrm/login/checkLogin','POST',(0,_extends3.default)({islanguid:langid,loginid:loginidRsa,userpassword:userpasswordRsa,dynamicPassword:dynamicPassword,tokenAuthKey:tokenAuthKey,validatecode:validatecode,validateCodeKey:validateCodeKey,logintype:logintype,messages:messages,isie:isIE9},plugin)).then(function(result){if('access_token'in result&&typeof result.access_token==='string'&&result.access_token!==''){localStorage.setItem('access_token',result.access_token);}else{localStorage.access_token&&localStorage.removeItem('access_token');}if(result.user_token&&result.user_token!=''){userpassword=result.user_token;}if(result.loginstatus=='true'){if(success&&typeof success=='function'){_antd.message.destroy();if(logintype==2){checkWeakPassword(function(){return success(loginid,userpassword,result);});}else{_ecCom.WeaTools.callApi('/api/hrm/login/remindLogin','POST',{logintype:logintype}).then(function(result){if(result.status=='1'){if(result.isUpPswd=='true'){if(failure&&typeof failure=='function')failure({reflashValidateCode:true});confirm({title:_i18n.i18n.confirm.systemhints(),content:getLabel('81626',"首次登录需修改密码！"),onOk:function onOk(){if(failure&&typeof failure=='function')failure({reflashValidateCode:true});showDialog("",'/spa/hrm/index_mobx.html#/main/hrm/password',{width:800,height:500});return;},onCancel:function onCancel(){if(failure&&typeof failure=='function')failure({reflashValidateCode:true});_ecCom.WeaTools.callApi('/api/hrm/login/checkLogout','POST',{}).then(function(result){});return;}});}else{if(result.passwdReminder=='1'){if(result.canpass=='1'){if(result.canremind=='1'){var content=getLabel('386479',"您的密码还有{params}天过期,是否现在修改?").replace('{params}',result.passwdelse);confirm({title:_i18n.i18n.confirm.systemhints(),content:content,onOk:function onOk(){if(failure&&typeof failure=='function')failure({reflashValidateCode:true});showDialog("",'/spa/hrm/index_mobx.html#/main/hrm/password',{width:800,height:500});return;},onCancel:function onCancel(){checkWeakPassword(function(){return success(loginid,userpassword,result);});}});}else{checkWeakPassword(function(){return success(loginid,userpassword,result);});}}else{confirm({title:_i18n.i18n.confirm.systemhints(),content:getLabel('386480',"您的密码已经过期,请立即修改！"),onOk:function onOk(){if(failure&&typeof failure=='function')failure({reflashValidateCode:true});showDialog("",'/spa/hrm/index_mobx.html#/main/hrm/password',{width:800,height:500});return;},onCancel:function onCancel(){if(failure&&typeof failure=='function')failure({reflashValidateCode:true});_ecCom.WeaTools.callApi('/api/hrm/login/checkLogout','POST',{}).then(function(result){});return;}});}}else{checkWeakPassword(function(){return success(loginid,userpassword,result);});}}}});}}}else{if(failure&&typeof failure=='function')failure({reflashValidateCode:true});_antd.message.destroy();var errorMsg=result.msg||getLabel('386481',"登录失败");var errorUrl='';var errorText='';if(result.msgcode=='120'){errorUrl='/spa/hrm/index_mobx.html#/main/hrm/BindTokenKey?langid='+langid;errorText=getLabel('386125',"令牌绑定");}else if(result.msgcode=='122'){errorUrl='/spa/hrm/index_mobx.html#/main/hrm/BindTokenKey?syncTokenKey=1&langid='+langid;errorText=getLabel('129202',"令牌同步");}else if(result.msgcode=='19'){window.doLicenseSubmit&&window.doLicenseSubmit();return;}// 返回错误信息提示
_antd.message.error(React.createElement('span',null,errorMsg,errorUrl?React.createElement('span',{style:{marginLeft:'5px',color:'#00a9ff',cursor:'pointer'},onClick:function onClick(){return showDialog('',errorUrl,{width:800,height:465});}},errorText):''),5);}});};var getDynamicPassword=function getDynamicPassword(params){var langid=params.langid,success=params.success,failure=params.failure;var openRSA=params.loginSetting.openRSA;var loginid=jQuery('#loginid').val();var userpassword=jQuery('#userpassword').val();var dynamicPassword=jQuery('#dynamicPassword').val();_antd.message.destroy();if(jQuery('#userpassword')&&jQuery('#userpassword').length>0){if(loginid==''||userpassword==''){_antd.message.error(getLabel('386478',"请输入用户名、密码"),3);if(failure&&typeof failure=='function')failure();return;}}if(openRSA&&openRSA=='1'){//启用RSA加密
__RSAEcrypt__.refreshRsaCode(function(){getDynamicPasswordSync(params);});}else{getDynamicPasswordSync(params);}};var getDynamicPasswordSync=function getDynamicPasswordSync(params){var langid=params.langid,success=params.success,failure=params.failure;var openRSA=params.loginSetting.openRSA;var loginid=jQuery('#loginid').val();var userpassword=jQuery('#userpassword').val();var loginidRsa=loginid;var userpasswordRsa=userpassword;if(openRSA&&openRSA=='1'){//启用RSA加密
loginidRsa=__RSAEcrypt__.rsa_data_encrypt(loginid);userpasswordRsa=__RSAEcrypt__.rsa_data_encrypt(userpassword);}_ecCom.WeaTools.callApi('/api/hrm/login/getDynamicPassword','POST',{langid:langid,loginid:loginidRsa,userpassword:userpasswordRsa}).then(function(result){if(result.status=='1'){if(success&&typeof success=='function'){success(result);}}else{_antd.message.destroy();var errorMsg=result.message;// 返回错误信息提示
_antd.message.error(React.createElement('span',null,errorMsg),5);}});};var showDialog=function showDialog(title,url,style,callback,onCancel){style=style||{width:800,height:465};var dialog=ecCom.WeaTools.createDialog({moduleName:'hrm',title:title,url:url,style:style,callback:callback,onCancel:onCancel});dialog.show();};var isdigit=function isdigit(s){var r,re;re=/\d*/i;//\d表示数字,*表示匹配多个数字
r=s.match(re);return r==s?true:false;};// 提供登录相关的全局方法
window.doLoginAction=function(actionName,params){if(actionName=='getLoginForm'){var langid=params.langid;_ecCom.WeaLocaleProvider.getLocaleLabelByLang(['common','hrm'],langid).then(function(){getLoginForm(params);});}else if(actionName=='login'){//异步加载ras文件
_loadjs2.default.isDefined('rsa')?_loadjs2.default.ready('rsa',function(){window.loginPlugin.willLogin(params,login);//login(params)
}):(0,_loadjs2.default)(["/js/rsa/jsencrypt.js","/js/rsa/rsa.js"],'rsa',{async:false,success:function success(){window.loginPlugin.willLogin(params,login);//login(params)
}});}else if(actionName=='getDynamicPassword'){_loadjs2.default.isDefined('rsa')?_loadjs2.default.ready('rsa',function(){getDynamicPassword(params);}):(0,_loadjs2.default)(["/js/rsa/jsencrypt.js","/js/rsa/rsa.js"],'rsa',{async:false,success:function success(){getDynamicPassword(params);}});}else if(actionName=='forgetPassword'){var url='/spa/hrm/index_mobx.html#/main/hrmSingle/forgetPassword?langid='+window.currLanguageId;//`/#/main/hrm/forgetPassword?langid=${window.currLanguageId}`;//`/spa/hrm/index_mobx.html#/main/hrm/forgetPassword?langid=${window.currLanguageId}`
showDialog(getLabel('127899',"找回密码"),url,{width:600,height:245});}};//window.doLoginAction('forgetPassword')

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(17);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(18), __esModule: true };

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
module.exports = __webpack_require__(0).Object.assign;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(6);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(28) });


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(21);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(7);
var createDesc = __webpack_require__(27);
module.exports = __webpack_require__(1) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(3);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(1) && !__webpack_require__(4)(function () {
  return Object.defineProperty(__webpack_require__(25)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(3);
var document = __webpack_require__(2).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(3);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(29);
var gOPS = __webpack_require__(40);
var pIE = __webpack_require__(41);
var toObject = __webpack_require__(42);
var IObject = __webpack_require__(10);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(4)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(30);
var enumBugKeys = __webpack_require__(39);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(8);
var toIObject = __webpack_require__(9);
var arrayIndexOf = __webpack_require__(32)(false);
var IE_PROTO = __webpack_require__(35)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(9);
var toLength = __webpack_require__(33);
var toAbsoluteIndex = __webpack_require__(34);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(12);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(12);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(36)('keys');
var uid = __webpack_require__(38);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(0);
var global = __webpack_require__(2);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(37) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 38 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 40 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 41 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(11);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_43__;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.i18n=undefined;var _defineProperty2=__webpack_require__(45);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _button,_confirm;var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var i18n=exports.i18n={module:{addressBook:function addressBook(){return getLabel(1515,'通讯录');},createResource:function createResource(){return getLabel(15005,'新建人员');},orgChart:function orgChart(){return getLabel(562,'组织图表');},trainRecord:function trainRecord(){return getLabel('816',"培训记录");},resourceChange:function resourceChange(){return getLabel('386396',"人员变动情况");}},label:{organization:function organization(){return getLabel(25332,'组织结构');},allCondition:function allCondition(){return getLabel(382085,'全部条件');},toBeSelected:function toBeSelected(){return getLabel(83302,'待选');},selected:function selected(){return getLabel(83303,'已选');},searchTemplateName:function searchTemplateName(){return getLabel(385087,'搜索模板名称');},commonConditions:function commonConditions(){return getLabel(32905,'常用条件');},pictureSizeSuggestedInfo:function pictureSizeSuggestedInfo(){return getLabel(386320,'建议使用的图片大小为:');},fillBasicInfo:function fillBasicInfo(){return getLabel(386322,'填写基本信息');},fillPrivateInfo:function fillPrivateInfo(){return getLabel(386323,'填写个人信息');},fillWorkInfo:function fillWorkInfo(){return getLabel(386324,'填写工作信息');},fillSysInfo:function fillSysInfo(){return getLabel(386325,'填写系统信息');},binding:function binding(){return getLabel(28032,'绑定');},dataNone:function dataNone(){return getLabel(84304,'暂无');},uploadPortrait:function uploadPortrait(){return getLabel(83080,'上传头像');},resourceCard:function resourceCard(){return getLabel(386343,'人员卡片');},fillSpecialtyIntroduction:function fillSpecialtyIntroduction(){return getLabel(386344,'请输入你的专长特点简要介绍');},specialtyIntroduction:function specialtyIntroduction(){return getLabel(383144,'专长介绍');},headImagePreview:function headImagePreview(){return getLabel(386349,'头像预览');},role:function role(){return getLabel(24055,'所属角色');},editRole:function editRole(){return getLabel(386351,'编辑所属角色');},addRole:function addRole(){return getLabel(386352,'添加所属角色');},securitySetting:function securitySetting(){return getLabel(32496,'安全设置');},all:function all(){return getLabel(82857,'全部');},today:function today(){return getLabel(130019,'今天');},yesterday:function yesterday(){return getLabel('82640',"昨天");},tswk:function tswk(){return getLabel(15539,'本周');},tsmth:function tsmth(){return getLabel(383428,'本月');},tssn:function tssn(){return getLabel(383465,'本季');},tsyr:function tsyr(){return getLabel(130017,'本年');},preMonth:function preMonth(){return getLabel(27347,'上个月');},preYear:function preYear(){return getLabel(81716,'上一年');},date:function date(){return getLabel(387106,'日期');},kqType:function kqType(){return getLabel(387107,'考勤类型');},dateRange:function dateRange(){return getLabel(32530,'指定日期范围');},sysManager:function sysManager(){return getLabel(16139,'系统管理员');},sysOpLog:function sysOpLog(){return getLabel(33258,'系统操作日志');},tokenNum:function tokenNum(){return getLabel(32897,"令牌序列号");},userKey:function userKey(){return getLabel(21597,"用户密钥");},autoEnable:function autoEnable(){return getLabel(131908,"自动启用");},enableDate:function enableDate(){return getLabel(31818,"启用日期");},enableMode:function enableMode(){return getLabel(131937,"启用方式");},sysInfo:function sysInfo(){return getLabel(15804,"系统信息");},sysLogiInfo:function sysLogiInfo(){return getLabel(130940,"系统登录信息");},weekSituation:function weekSituation(){return getLabel(130941,"一周情況");},ageStatus:function ageStatus(){return getLabel('386388',"年龄状况");},genderStatus:function genderStatus(){return getLabel('386389',"性别状况");},workingAgeStatus:function workingAgeStatus(){return getLabel('386390',"工龄状况");},eduStatus:function eduStatus(){return getLabel('386391',"学历状况");},maritalStatus:function maritalStatus(){return getLabel('469',"婚姻状况");},proTitleStatus:function proTitleStatus(){return getLabel('386392',"职称统计");},rankStatus:function rankStatus(){return getLabel('386393',"职级统计");},workNature:function workNature(){return getLabel('804',"用工性质");},stateStatistics:function stateStatistics(){return getLabel('386394',"状态统计");},securtitylevel:function securtitylevel(){return getLabel('683',"安全级别");},subordinated:function subordinated(){return getLabel(30805,'的下属');},trainingArrangements:function trainingArrangements(){return getLabel('6156',"培训安排");},ranking:function ranking(){return getLabel('19082',"排名");},newTypeOfContract:function newTypeOfContract(){return getLabel('382214',"新签合同种类");},specificInformation:function specificInformation(){return getLabel('15729',"具体信息");},intoStatistics:function intoStatistics(){return getLabel('386397',"调入统计");},outOfStatistics:function outOfStatistics(){return getLabel('386405',"调出统计");},lossStatistics:function lossStatistics(){return getLabel('386398',"流失统计");},turnoverStatistics:function turnoverStatistics(){return getLabel('386399',"离职统计");},dismissalStatistics:function dismissalStatistics(){return getLabel('15978',"解聘统计");},retirementStatistics:function retirementStatistics(){return getLabel('16031',"退休统计");},newSignStatistics:function newSignStatistics(){return getLabel('386400',"新签统计");},expiryStatistics:function expiryStatistics(){return getLabel('386401',"到期统计");},newSituation:function newSituation(){return getLabel('16565',"新增情况");},correction:function correction(){return getLabel('16566',"转正情况");},mobility:function mobility(){return getLabel('16564',"调动情况");},renewTheSituation:function renewTheSituation(){return getLabel('16567',"续签情况");},returnOnTheSituation:function returnOnTheSituation(){return getLabel('16568',"返聘情况");},lossOfPersonnel:function lossOfPersonnel(){return getLabel('382249',"人员流失情况");},contractSituation:function contractSituation(){return getLabel('16572',"合同情况");},customerInfo:function customerInfo(){return getLabel('17088',"自定义信息");},templateName:function templateName(){return getLabel('28050',"模板名称");},ageRange:function ageRange(){return getLabel('15860',"年龄区间");},workingAgeRange:function workingAgeRange(){return getLabel('15927',"工龄区间");},rankingInterval:function rankingInterval(){return getLabel('15871',"职级区间");},level:function level(){return getLabel('15872',"级");},year:function year(){return getLabel('26577',"年");},signInDetail:function signInDetail(){return getLabel('20241',"签到明细");},signOutDetail:function signOutDetail(){return getLabel('20242',"签退明细");},lateDetail:function lateDetail(){return getLabel('20088',"迟到明细");},absentlateDetail:function absentlateDetail(){return getLabel('383164',"缺勤明细");},earlyRetreatDetail:function earlyRetreatDetail(){return getLabel('20089',"早退明细");},absenteeismDetail:function absenteeismDetail(){return getLabel('20090',"旷工明细");},leakageOfSignatureDetail:function leakageOfSignatureDetail(){return getLabel('20091',"漏签明细");},leaveDetail:function leaveDetail(){return getLabel('20092',"请假明细");},businessTripDetail:function businessTripDetail(){return getLabel('20093',"出差明细");},publicDetail:function publicDetail(){return getLabel('20094',"公出明细");},overtimeWorkDetail:function overtimeWorkDetail(){return getLabel('33501',"加班明细");},attendanceAnomalyDetail:function attendanceAnomalyDetail(){return getLabel('386409',"考勤异常数据抵冲明细");},reportDate:function reportDate(){return getLabel('20087',"报表生成日期");},daytime:function daytime(){return getLabel(390,'日');},day:function day(){return getLabel(1925,'天');},hour:function hour(){return getLabel('391',"小时");},month:function month(){return getLabel(6076,'月');},monday:function monday(){return getLabel(392,'星期一');},tuesday:function tuesday(){return getLabel(393,'星期二');},wednesday:function wednesday(){return getLabel(394,'星期三');},thursday:function thursday(){return getLabel(395,'星期四');},friday:function friday(){return getLabel(396,'星期五');},saturday:function saturday(){return getLabel(397,'星期六');},sunday:function sunday(){return getLabel(398,'星期日');},preview:function preview(){return getLabel(221,'预览');},select:function select(){return getLabel(126832,'选择');},'15809':function _(){return getLabel('15809',"已设置");},'15808':function _(){return getLabel('15808',"未设置");},'26471':function _(){return getLabel('26471',"停用");},'388923':function _(){return getLabel('388923',"确定要停用该人员的二次验证密码吗？");},'388924':function _(){return getLabel('388924',"为确保账户安全，请及时通知该用户重置密码！");},importResult:function importResult(){return getLabel(82341,'导入结果');},styleSettings:function styleSettings(){return getLabel(512524,'样式设置');}},button:(_button={collect:function collect(){return getLabel(28111,'收藏');},log:function log(){return getLabel(83,'日志');},helper:function helper(){return getLabel(275,'帮助');},search:function search(){return getLabel(82529,'搜索');},research:function research(){return getLabel('364',"重新搜索");},reset:function reset(){return getLabel(27088,'重置');},ok:function ok(){return getLabel(33703,'确定');},cancel:function cancel(){return getLabel(32694,'取消');},create:function create(){return getLabel(365,'新建');},remove:function remove(){return getLabel(20230,'移除');},delete:function _delete(){return getLabel(131966,'删除');},modify:function modify(){return getLabel(93,'编辑');},transfer:function transfer(){return getLabel(80,'转移');},multiRemove:function multiRemove(){return getLabel(383696,'批量移除');},multiDelete:function multiDelete(){return getLabel(32136,'批量删除');},save:function save(){return getLabel(30986,'保存');},saveAs:function saveAs(){return getLabel(131623,'另存为');},done:function done(){return getLabel(555,'完成');},saveAsTemplate:function saveAsTemplate(){return getLabel(18418,'存为模板');},conditionDef:function conditionDef(){return getLabel(386317,'常用条件定制');},directSubordinates:function directSubordinates(){return getLabel(386318,'显示直接下属');},DisplaySubordinateSubordinates:function DisplaySubordinateSubordinates(){return getLabel(83783,'显示下级下属');},columnVisibleSetting:function columnVisibleSetting(){return getLabel(32535,'显示列定制');},saveAndCreate:function saveAndCreate(){return getLabel(32720,'保存并新建');},fullModle:function fullModle(){return getLabel(386321,'进入完整模式');},lastStep:function lastStep(){return getLabel(1876,'上一步');},nextStep:function nextStep(){return getLabel(1402,'下一步');},back:function back(){return getLabel(1290,'返回');},scanAddContacts:function scanAddContacts(){return getLabel(385903,'扫描添加联系人');},collapse:function collapse(){return getLabel(26985,'收起');},expand:function expand(){return getLabel(15315,'展开');},companyWechat:function companyWechat(){return getLabel(383148,'微信企业号绑定');},putOn:function putOn(){return getLabel(386345,'贴上');},zoomIn:function zoomIn(){return getLabel(22209,'缩小');},zoomOut:function zoomOut(){return getLabel(22208,'放大');},clickUpload:function clickUpload(){return getLabel(386346,'点击上传');},reUpload:function reUpload(){return getLabel(131107,'重新上传');},removeHeadImg:function removeHeadImg(){return getLabel(386347,'删除头像');},rotate:function rotate(){return getLabel(386348,'旋转');}},(0,_defineProperty3.default)(_button,'multiRemove',function multiRemove(){return getLabel(383696,'批量移除');}),(0,_defineProperty3.default)(_button,'multiDelete',function multiDelete(){return getLabel(32136,'批量删除');}),(0,_defineProperty3.default)(_button,'add',function add(){return getLabel(131201,'添加');}),(0,_defineProperty3.default)(_button,'clickSetting',function clickSetting(){return getLabel(386368,'点击设置');}),(0,_defineProperty3.default)(_button,'more',function more(){return getLabel(131654,'更多');}),(0,_defineProperty3.default)(_button,'saveAsImage',function saveAsImage(){return getLabel(385746,'另存为图片');}),(0,_defineProperty3.default)(_button,'import',function _import(){return getLabel(18596,'导入');}),(0,_defineProperty3.default)(_button,'export',function _export(){return getLabel(28343,'导出Excel');}),(0,_defineProperty3.default)(_button,'export1',function export1(){return getLabel(383381,'导出清单到Excel');}),(0,_defineProperty3.default)(_button,'refresh',function refresh(){return getLabel(354,'刷新');}),(0,_defineProperty3.default)(_button,'saveAndSetting',function saveAndSetting(){return getLabel(32159,'保存并进入详细设置');}),(0,_defineProperty3.default)(_button,'importHistoryQuery',function importHistoryQuery(){return getLabel(24644,'历史导入记录');}),(0,_defineProperty3.default)(_button,'submit',function submit(){return getLabel(615,'提交');}),(0,_defineProperty3.default)(_button,'verification',function verification(){return getLabel('15357',"验证");}),(0,_defineProperty3.default)(_button,'changeValidType',function changeValidType(){return getLabel('387341',"更换其他验证方式");}),(0,_defineProperty3.default)(_button,'resend',function resend(){return getLabel('22408',"重新发送");}),(0,_defineProperty3.default)(_button,'getImportLog',function getImportLog(){return getLabel(24835,'导入日志');}),_button),confirm:(_confirm={defaultTitle:function defaultTitle(){return getLabel(131329,'信息确认');},systemhints:function systemhints(){return getLabel(15172,'系统提示');},remove:function remove(){return getLabel(83449,'确定要移除吗？');},delete:function _delete(){return getLabel(83877,'确定要删除吗？');},removeSelected:function removeSelected(){return getLabel(385639,'确定要移除选择的记录吗？');},deleteSelected:function deleteSelected(){return getLabel(385625,'确定要删除选择的记录吗？');}},(0,_defineProperty3.default)(_confirm,'delete',function _delete(){return getLabel(83877,'确定要删除吗？');}),(0,_defineProperty3.default)(_confirm,'batchDeleteConfirm',function batchDeleteConfirm(){return getLabel(385625,'确定要删除选择的记录吗？');}),_confirm),message:{dataConstructError:function dataConstructError(){return getLabel(385643,'数据格式异常');},authFailed:function authFailed(){return getLabel(2012,'对不起，您暂时没有权限！');},actionError:function actionError(){return getLabel(132200,'操作失败！');},opSuccess:function opSuccess(){return getLabel(384136,'操作成功');},saveSuccess:function saveSuccess(){return getLabel(83551,'保存成功！');},saveFailed:function saveFailed(){return getLabel(84544,'保存失败！');},removeSuccess:function removeSuccess(){return getLabel(385950,'移除成功！');},deleteSuccess:function deleteSuccess(){return getLabel(83472,'删除成功！');},dataEmpty:function dataEmpty(){return getLabel(82241,'不能为空');},serverProcessing:function serverProcessing(){return getLabel(84041,'服务器正在处理，请稍候...');},dataNone:function dataNone(){return getLabel(83553,'暂无数据');},recordNotFound:function recordNotFound(){return getLabel(83781,'没有数据');},noMatchingData:function noMatchingData(){return getLabel(384284,'暂无匹配数据');},requireFieldNone:function requireFieldNone(){return getLabel(386319,'必填字段不完整！');},fillPrivateInfoAlarm:function fillPrivateInfoAlarm(){return getLabel(386326,'个人信息栏目未开放,如有需要请联系管理员开放!');},fillWorkInfoAlarm:function fillWorkInfoAlarm(){return getLabel(386327,'工作信息栏目未开放,如有需要请联系管理员开放!');},fillSysInfoAlarm:function fillSysInfoAlarm(){return getLabel(386328,'系统信息栏目未开放或者无权限,请联系管理员!');},noAvailableCheckoutMethod:function noAvailableCheckoutMethod(){return getLabel(386367,'没有可用的校验方式');},noAvailableCheckMode:function noAvailableCheckMode(){return getLabel(386369,'没有可用的校验方式，请点击设置！');},fillTelphoneNum:function fillTelphoneNum(){return getLabel(386370,'请填写手机号！');},fillAvailableTelphoneNum:function fillAvailableTelphoneNum(){return getLabel(386371,'请填写正确手机号！');},fillUserKey:function fillUserKey(){return getLabel(386372,'请填写用户密钥');},bindToken:function bindToken(){return getLabel(386373,'请绑定令牌序列号！');},tokenNumLen:function tokenNumLen(){return getLabel(83745,'令牌序列号必须为10位数字！');},tokenBinded:function tokenBinded(){return getLabel(386374,'令牌序列号已经绑定给{params}，不能重复绑定！');},htKey:function htKey(){return getLabel(83061,'您的浏览器不支持修改使用海泰key的账号密码，请使用IE浏览器');},pleaseUploadFile:function pleaseUploadFile(){return getLabel(384197,'请上传文件');},pleaseSelectDelRecord:function pleaseSelectDelRecord(){return getLabel(387095,'请选择要删除的记录');},checkPhoneVCode:function checkPhoneVCode(){return getLabel('387363',"手机验证码已发送到手机{params}");},checkMailVCode:function checkMailVCode(){return getLabel('387364',"随机验证码已发送到邮箱{params}");},checkVCode:function checkVCode(){return getLabel('125973',"请注意查收！");},doubleCheckPwdFaild:function doubleCheckPwdFaild(){return getLabel(81608,'密码验证不通过，请重新输入！');},vCodeExpired:function vCodeExpired(){return getLabel('387398',"验证码已过期");},pwdLen:function pwdLen(){return getLabel('20172',"密码长度不能小于");},pwdType:function pwdType(){return getLabel('512768',"新密码不符合要求，必须包含字母大写、字母小写、数字！请重新输入！");},pwdType1:function pwdType1(){return getLabel('512769',"新密码不符合要求，必须包含字母、数字、特殊字符！请重新输入！");},pwdType2:function pwdType2(){return getLabel('512767',"新密码不符合要求，必须包含字母、数字！请重新输入！");},selectImportTempleteError:function selectImportTempleteError(){return getLabel(384059,'导入文件存在以下错误，请解决后重新上传！');}},smallType:{HRM_RSOURCE_CARD:1,//人员卡片
HRM_RSOURCE_CARD_BASE:2,//人员卡片基本信息
HRM_RSOURCE_CARD_PERSONAL:3,//人员卡片个人信息
HRM_RSOURCE_CARD_WORK:4,//人员卡片工作信息
HRM_RSOURCE_CARD_SYSTEM:5,//人员卡片系统信息
HRM_RSOURCE_CARD_GROUP:6,//人员卡片常用组
//HRM_RSOURCE_CARD_ROLE: 7,//人员卡片角色设置
HRM_RSOURCE_CARD_FINANCE:16,//人员卡片工资福利
HRM_RSOURCE_ADD:8,//新建人员
HRM_RSOURCE_ADD_BASE:8,//新建人员基本信息
HRM_RSOURCE_ADD_PERSONAL:10,//新建人员个人信息
HRM_RSOURCE_ADD_WORK:11,//新建人员工作信息
HRM_RSOURCE_ADD_SYSTEM:12,//新建人员系统信息
HRM_PASSWPRD:13,//密码设置
HRM_RSOURCEMANAGER:14,//管理员
HRM_RSOURCEMANAGER_SECURITYSETTING:15//管理员卡片安全设置
}};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(46);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(47), __esModule: true };

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(48);
var $Object = __webpack_require__(0).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(1), 'Object', { defineProperty: __webpack_require__(7).f });


/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_49__;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _classCallCheck2=__webpack_require__(14);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _loginDeufaultPlugin=__webpack_require__(51);var _loginDeufaultPlugin2=_interopRequireDefault(_loginDeufaultPlugin);var _ecCom=__webpack_require__(5);var _loadjs=__webpack_require__(13);var _loadjs2=_interopRequireDefault(_loadjs);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LoginPluginFactory=function LoginPluginFactory(){var _this=this;(0,_classCallCheck3.default)(this,LoginPluginFactory);this.getLocalPlugin=function(params,callback){var plugin=params.plugin;if(plugin){if(plugin.code=='load'){if(plugin.type='file'){var jsName=plugin.name;if(_loadjs2.default.isDefined(jsName)){_loadjs2.default.ready(jsName,function(){if(console)console.log(window.loginPlugin);_this.donePlugin(callback);});}else{(0,_loadjs2.default)([plugin.url],jsName,{async:false,success:function success(){if(console)console.log(window.loginPlugin);_this.donePlugin(callback);}});}}}else{window.loginPlugin=new _loginDeufaultPlugin2.default();}}else{window.loginPlugin=new _loginDeufaultPlugin2.default();}};this.getLoginPlugin=function(params,callback){var loginid=params.loginid;_ecCom.WeaTools.callApi('/api/hrm/login/checkPlugin','POST',{loginid:loginid}).then(function(data){if(data.code=='load'){if(data.type='file'){var jsName=data.name;if(_loadjs2.default.isDefined(jsName)){_loadjs2.default.ready(jsName,function(){if(console)console.log(window.loginPlugin);_this.donePlugin(callback);});}else{(0,_loadjs2.default)([data.url],jsName,{async:false,success:function success(){if(console)console.log(window.loginPlugin);_this.donePlugin(callback);}});}}}else{window.loginPlugin=new _loginDeufaultPlugin2.default();}}).catch(function(err){if(console)console.log(err);});};this.donePlugin=function(callback){callback&&callback();};}// unused
;exports.default=LoginPluginFactory;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _classCallCheck2=__webpack_require__(14);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LoginDeufaultPlugin=function LoginDeufaultPlugin(){(0,_classCallCheck3.default)(this,LoginDeufaultPlugin);this.name='defaultPlugin';this.init=function(){};this.willLogin=function(params,callback){callback(params);};};exports.default=LoginDeufaultPlugin;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// loginNew.js?v=ee96d33b